/**
 * How Retailers selected to pay.
 */
export var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm["UNSPECIFIED"] = "UNSPECIFIED";
    PaymentTerm["HOLD_ON_PLACEMENT"] = "HOLD_ON_PLACEMENT";
    PaymentTerm["PAYMENT_ON_SHIPMENT"] = "PAYMENT_ON_SHIPMENT";
    PaymentTerm["NET90"] = "NET90";
    PaymentTerm["CONSIGNMENT"] = "CONSIGNMENT";
    PaymentTerm["NET90_ON_FIRST_ORDER"] = "NET90_ON_FIRST_ORDER";
    PaymentTerm["NET60"] = "NET60";
    PaymentTerm["NET60_ON_FIRST_ORDER"] = "NET60_ON_FIRST_ORDER";
    PaymentTerm["NET30"] = "NET30";
    PaymentTerm["INSTALLMENTS"] = "INSTALLMENTS";
})(PaymentTerm || (PaymentTerm = {}));
